"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullUser = exports.User = exports.FindUser = exports.SearchUserAgency = exports.SearchUser = void 0;
var cerealParse_1 = require("../cerealParse");
var client_1 = require("./client");
/**
 * Search user model.
 */
var SearchUser = /** @class */ (function () {
    function SearchUser(id, commonName, agencies) {
        this.id = id;
        this.commonName = commonName;
        this.agencies = agencies;
    }
    /**
     * Check if search user has agency with id.
     * @param agencyId
     * @param True if user has agency with specified id.
     */
    SearchUser.prototype.hasAgencyWithId = function (agencyId) {
        return this.agencies.filter(function (a) { return a.id == agencyId; }).length > 0;
    };
    /**
     * Parse object potentially representing a SearchUser.
     * @param o
     * @return Parse result
     */
    SearchUser.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SearchUser(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'commonName'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'agencies', SearchUserAgency.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SearchUser Model: " + e.message);
        }
    };
    return SearchUser;
}());
exports.SearchUser = SearchUser;
/**
 * Class representing a serach user agency.
 */
var SearchUserAgency = /** @class */ (function () {
    function SearchUserAgency(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse object potentially representing a SearchUserAgency.
     * @param o
     * @return Parse result
     */
    SearchUserAgency.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SearchUserAgency(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SearchUserAgency Model: " + e.message);
        }
    };
    return SearchUserAgency;
}());
exports.SearchUserAgency = SearchUserAgency;
/**
 * Find user model.
 */
var FindUser = /** @class */ (function () {
    function FindUser(id, commonName, email) {
        this.id = id;
        this.commonName = commonName;
        this.email = email;
    }
    /**
     * Parse object potentially representing a FindUser.
     * @param o
     * @return Parse result
     */
    FindUser.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FindUser(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'commonName'), cerealParse_1.ParseUtils.getString(o, 'email')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FindUser Model: " + e.message);
        }
    };
    return FindUser;
}());
exports.FindUser = FindUser;
/**
 * Class representing a user.
 */
var User = /** @class */ (function () {
    function User(id, givenName, surname, commonName, email, isManager, lastSeen) {
        this.id = id;
        this.givenName = givenName;
        this.surname = surname;
        this.commonName = commonName;
        this.email = email;
        this.isManager = isManager;
        this.lastSeen = lastSeen;
    }
    /**
     * Parse object potentially representing an User.
     * @param o
     * @return Parse result
     */
    User.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new User(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'givenName'), cerealParse_1.ParseUtils.getString(o, 'surname'), cerealParse_1.ParseUtils.getString(o, 'commonName'), cerealParse_1.ParseUtils.getString(o, 'email'), cerealParse_1.ParseUtils.getBoolean(o, 'isManager'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'lastSeen')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid User Model: " + e.message);
        }
    };
    return User;
}());
exports.User = User;
/**
 * Class representing a full user.
 */
var FullUser = /** @class */ (function () {
    function FullUser(id, type, givenName, surname, commonName, email, phoneNumber, isManager) {
        this.id = id;
        this.type = type;
        this.givenName = givenName;
        this.surname = surname;
        this.commonName = commonName;
        this.email = email;
        this.phoneNumber = phoneNumber;
        this.isManager = isManager;
    }
    /**
     * Get basic info about user.
     * @TODO Convert to a get function.
     * @return Basic user info.
     */
    FullUser.prototype.getBasicInfo = function () {
        return {
            givenName: this.givenName,
            surname: this.surname,
            commonName: this.commonName,
            phoneNumber: this.phoneNumber,
        };
    };
    /**
     * Set basic user info.
     * @TODO Update to set function.
     * @param info Basic user info.
     */
    FullUser.prototype.updateWithBasicInfo = function (info) {
        if (info.givenName != null) {
            this.givenName = info.givenName;
        }
        if (info.surname != null) {
            this.surname = info.surname;
        }
        if (info.commonName != null) {
            this.commonName = info.commonName;
        }
        if (info.phoneNumber != null) {
            this.phoneNumber = info.phoneNumber;
        }
    };
    /**
     * Get difference between passed user info and current user info.
     * @param info Basic user info to compare.
     * @return Basic user info differences.
     */
    FullUser.prototype.getBasicInfoDifference = function (info) {
        return {
            givenName: info.givenName != this.givenName ? info.givenName : null,
            surname: info.surname != this.surname ? info.surname : null,
            commonName: info.commonName != this.commonName ? info.commonName : null,
            phoneNumber: info.phoneNumber != this.phoneNumber ? info.phoneNumber : null,
        };
    };
    /**
     * Create ne client instance from user.
     * @return Client instance representing user.
     */
    FullUser.prototype.toClient = function () {
        return new client_1.Client(this.id, this.commonName, client_1.AgencyClientType.user);
    };
    /**
     * Parse object potentially representing a FullUser.
     * @param o
     * @return Parse result
     */
    FullUser.parse = function (o) {
        try {
            var userPart = User.parse(o);
            if (userPart.success == false) {
                return cerealParse_1.ParseUtils.parseFailure("Invalid FullUser: " + userPart.justification);
            }
            return cerealParse_1.ParseUtils.parseSuccess(new FullUser(userPart.value.id, 'user', userPart.value.givenName, userPart.value.surname, userPart.value.commonName, userPart.value.email, cerealParse_1.ParseUtils.getStringOrNull(o, 'phone'), userPart.value.isManager));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullUser: " + e.message);
        }
    };
    return FullUser;
}());
exports.FullUser = FullUser;
//# sourceMappingURL=user.js.map